module.exports = __webpack_public_path__ + "img/lasource-3.76ab29ba.jpg";